module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setupDetails":"EDI Setup","otherOptions":"Other options","codelist":"Codelists"},"no":{"setupDetails":"EDI oppsett","otherOptions":"Andre instillinger","codelist":"Kodelister"}}')
  delete Component.options._Ctor
}
